const yup = require("yup");

const passwordRequirements = yup.object().shape({
  password: yup
    .string()
    .min(6, "Password minimum 6 characters")
    .matches(/^(?=.*[A-Z])/, "Password must contain one uppercase character")
    .matches(
      /[!+@#$%^&*()\-_"=+{}; :,<.>]/,
      "Password must contain one special character",
    )
    .required("Password is required"),
  newPassword: yup
    .string()
    .min(6, "New Password minimum 6 characters")
    .matches(
      /^(?=.*[A-Z])/,
      "New Password must contain one uppercase character",
    )
    .matches(
      /[!+@#$%^&*()\-_"=+{}; :,<.>]/,
      "New Password must contain one special character",
    )
    .required("New Password is required"),
  reTypePassword: yup
    .string()
    .min(6, "Re-type Password minimum 6 characters")
    .matches(
      /^(?=.*[A-Z])/,
      "Re-type Password must contain one uppercase character",
    )
    .matches(
      /[!+@#$%^&*()\-_"=+{}; :,<.>]/,
      "Re-type Password must contain one special character",
    )
    .required("Re-type Password is required")
    .oneOf([yup.ref("newPassword")], "Passwords must match"),
});
export default passwordRequirements;
